import { render, staticRenderFns } from "./ReleasesBudgetEditPanel.vue?vue&type=template&id=d22de7ca"
import script from "./ReleasesBudgetEditPanel.vue?vue&type=script&lang=js"
export * from "./ReleasesBudgetEditPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports